import { RootState } from '@/core/redux';
import { PaymentService } from '@/features/payment/services/Payment.service';
import { PackageInfoWithPromoCodeArgs, PackageInfoWithPromoCode } from '@/features/account/types';

export const getPackageInformationWithPromoCode = (
  state: RootState,
  args: PackageInfoWithPromoCodeArgs,
): PackageInfoWithPromoCode | undefined =>
  PaymentService.endpoints?.requestPackageInformationWithPromoCode.select(args)(state)?.data;
